const FiltersStoragePlugin = {
  install(app, options) {
    app.config.globalProperties.$filtersStorage = {
      restoreFiltersStorage(key, defaultFilters) {
        const savedFilters = JSON.parse(sessionStorage.getItem(key));
        return savedFilters || defaultFilters;
      },

      save(key, filters) {
        sessionStorage.setItem(key, JSON.stringify(filters));
      },

      clear(key) {
        sessionStorage.removeItem(key);
      },

      mountedFilters(path, key, defaultFilters) {
        options.router.afterEach(to => {
          if (!to.path.includes(path)) sessionStorage.removeItem(key);
        });
        return this.restoreFiltersStorage(key, defaultFilters);
      }
    };
  }
};

export default FiltersStoragePlugin;
